if (!customElements.get('share-button')) {
  customElements.define('share-button', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.details = this.querySelector('details');
      this.input = this.querySelector('input');
      this.message = this.querySelector('[role="status"]');
      this.updateUrl(this.input.value);
      this.querySelector('summary').addEventListener('click', async event => {
        if (!navigator.share || this.details.open) return;
        event.preventDefault();
        try { await navigator.share({ title: document.title, url: this.urlToShare }); }
        catch (error) { if (error.name !== 'AbortError') this.details.open = true; }
      });
      this.querySelector('.share-button__copy').addEventListener('click', async () => {
        try {
          if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(this.urlToShare);
          else throw new Error('Clipboard unavailable');
          this.message.textContent = this.dataset.success;
        } catch {
          this.input.focus(); this.input.select();
          let copied = false;
          try { copied = document.execCommand('copy'); } catch {}
          this.message.textContent = copied ? this.dataset.success : this.dataset.manual;
        }
      });
      this.querySelector('.share-button__close').addEventListener('click', () => { this.details.open = false; this.querySelector('summary').focus(); });
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.details.open = false; this.querySelector('summary').focus(); } });
    }
    updateUrl(value) {
      const url = new URL(value, location.origin);
      url.searchParams.delete('preview_theme_id');
      this.urlToShare = url.href;
      const input = this.querySelector('input');
      if (input) input.value = this.urlToShare;
      const whatsapp = this.querySelector('.lc-share-whatsapp');
      if (whatsapp) whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(document.title + ' ' + this.urlToShare);
    }
  });
}
